"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapHasNestedFilter = mapHasNestedFilter;
function mapHasNestedFilter(filter, schema) {
    // Return undefined when value is false
    if (filter.value === false) {
        return undefined;
    }
    // Get schema shape that matches the filter field
    const filterAttribute = schema.filterableAttributes.find((attr) => attr.field === filter.field);
    // If field not found in schema, fall back to using the field name directly
    if (!filterAttribute) {
        console.error('filter attribute not found', filter);
        return {
            exists: {
                field: String(filter.field),
            },
        };
    }
    // prioritize mapTo (alternative mapping) over field
    const field = filterAttribute.mapTo || String(filterAttribute.field);
    // If mapTo is available, return simple exists query
    if (filterAttribute.mapTo) {
        return {
            exists: {
                field,
            },
        };
    }
    // If mapTo is not available, return nested query structure
    const nestedPath = String(filterAttribute.field);
    const result = {
        nested: {
            path: nestedPath,
            query: {
                exists: {
                    field: nestedPath,
                },
            },
        },
    };
    return result;
}
//# sourceMappingURL=map-has-nested-filter.js.map